import SignUpData from "../components/signupdata";

function SignUp() {

    return(
        
        <SignUpData/>
    )


}
export default SignUp;